import React from 'react';
import { Card, Form } from 'semantic-ui-react';

const FilterCard = ({ filterValue, updateFilter }) => {
  return (
    <Card fluid>
      <Card.Content>
        <Form.Input
          fluid
          label="Zoek kliniek"
          value={filterValue}
          onChange={updateFilter}
        />
      </Card.Content>
    </Card>
  );
};

export default FilterCard;



// WEBPACK FOOTER //
// ./src/components/Hospitals/SubComponents/Cards/FilterCard.js